import {WhitelabelEventWithPayload} from "../../../common/ts/events/Events";
import {EventConstructor} from "../../../common/ts/core/http";
import SaveSearchModal from "../../../common/ts/components/modals/retention/SaveSearchModal";
import {SaveSearchModalInterface} from "../../../common/ts/components/modals/retention/SaveSearchModalInterface";

interface SerpLoadedPayload {
    search: string,
    shouldShowEmailRetentionModal: boolean,
    saveSearchModal: SaveSearchModalInterface,
    shouldShowProjectSnippet: boolean,
    shouldRequestWebPushPermission: boolean,
    shouldShowGoogleOneTapOnLoad: boolean,
    storedSearches: string | null,
    operationType: string,
    filters: string,
    geoEntity: string,
    pageviewId: string,
    serpUrl: string,
    device: string,
    isGDPRCountry: boolean,
}

export class SerpLoadedEvent implements WhitelabelEventWithPayload<SerpLoadedPayload> {
    type: string;
    static readonly TYPE: string = 'serp-loaded';
    payload: SerpLoadedPayload;

    constructor(payload: SerpLoadedPayload) {
        this.type = SerpLoadedEvent.TYPE;
        this.payload = payload;
    }
}

export interface SerpClickSimilarAdsRequestedPayload {
    adId: string,
    numberOfAds: number,
    search: string,
    ids: (string | null)[],
    pageSectionId: string,
    pageViewId: string,
    successEventClass: EventConstructor,
    findIntent: { [key: string]: string },
}


export class SerpClickSimilarAdsRequestedEvent implements WhitelabelEventWithPayload<SerpClickSimilarAdsRequestedPayload> {
    type: string;
    static readonly TYPE: string = 'serp-click-similar-ads-requested';
    payload: SerpClickSimilarAdsRequestedPayload;

    constructor(payload: SerpClickSimilarAdsRequestedPayload) {
        this.type = SerpClickSimilarAdsRequestedEvent.TYPE;
        this.payload = payload;
    }
}

export interface SerpProjectsLoadedSuccessfullyPayload  {
    response: string,
}

export class SerpProjectsLoadedSuccessfullyEvent implements WhitelabelEventWithPayload<SerpProjectsLoadedSuccessfullyPayload> {
    type: string;
    static readonly TYPE: string = 'serp-projects-loaded-successfully';
    payload: SerpProjectsLoadedSuccessfullyPayload;

    constructor(payload: SerpProjectsLoadedSuccessfullyPayload) {
        this.type = SerpProjectsLoadedSuccessfullyEvent.TYPE;
        this.payload = payload;
    }

}
